import { Divider } from '@mui/material'
import Box from '@mui/material/Box'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { getProducts } from '../../api/product'
import Navigation from '../../components/common/navigation'
import SelectBrand from '../../components/common/SelectBrand'
import SelectCategory from '../../components/common/SelectCategory'
import ItemSearchBar from '../../components/promotion/ItemSearchBar'
import ProductSearchTable from '../../components/promotion/ProductSearchTable'
import ImageSlider from '../../components/promotion/Slider'
import RadioSelect from '../../components/RadioSelect'
import { Button } from '../../element/Button'
import { MAX_PRODUCT } from './promoRegister'

const RegisterProduct = ({ setOnRegister, setCampaign, campaign }) => {
  const [keyword, setKeyword] = useState('')
  const [items, setItems] = useState([])
  const [checked, setChecked] = useState(campaign.products)
  const [option, setOption] = useState({
    page: 1,
    count: 0,
    brand: '',
    category: { id: null, name: '', korName: '', children: [], parent: null },
    isDiscount: '',
  })
  useEffect(() => {
    ;(async () => {
      const { data, count } = await getProducts(
        option.page,
        option.category.id,
        keyword,
        null,
        null,
        option.brand,
        null,
        null,
        option.isDiscount,
        true
      )
      setItems(data)
      setOption((prev) => ({
        ...prev,
        count: count,
      }))
    })()
  }, [option.page])

  const updateItems = () => {
    const result = Array.from(
      checked.reduce((map, obj) => map.set(obj.id, obj), new Map()).values()
    )

    if (result.length > MAX_PRODUCT) {
      return alert(`최대 ${MAX_PRODUCT}개까지 등록가능합니다.`)
    }

    setCampaign((prev) => ({ ...prev, products: result }))
    setChecked([])
    setOnRegister(null)
  }

  const search = async (keyword) => {
    if (option.page === 1) {
      const { data, count } = await getProducts(
        1,
        option.category.id,
        keyword,
        'SELLING',
        'APPROVED',
        option.brand,
        null,
        null,
        option.isDiscount
      )
      setItems(data)
      setOption((prev) => ({ ...prev, count: count }))
    } else {
      setOption((prev) => ({ ...prev, page: 1 }))
    }
  }

  return (
    <Box sx={boxStyle}>
      <Box display="flex" alignItems="center" gap={3}>
        <SubTitle>상품 추가</SubTitle>
      </Box>

      <Divider sx={{ height: 16 }} />

      <Box
        sx={{ marginTop: 3, marginBottom: 1 }}
        display="flex"
        alignItems="center"
        gap={3}
      >
        <SubTitle>추가된 상품 {checked.length}개</SubTitle>
      </Box>

      <ImageSlider images={defaultImage(checked.map((c) => c.imgs[0]))} />

      <Box
        marginY="20px"
        gap={1.5}
        sx={{ marginTop: 0, display: 'flex', alignItems: 'center' }}
      >
        <SelectCategory category={option.category} setOption={setOption} />
      </Box>

      <Box
        marginY="20px"
        gap={3}
        sx={{ marginTop: 0, display: 'flex', alignItems: 'center' }}
      >
        <SelectBrand value={option.brand} setValue={setOption} />
      </Box>

      <Box marginY="20px">
        <RadioSelect
          width="auto"
          label="할인상태"
          list={[
            { name: '전체', value: '' },
            { name: '할인', value: true },
            { name: '미할인', value: false },
          ]}
          setState={(value) => {
            setOption({
              ...option,
              isDiscount: value,
            })
          }}
          state={option.isDiscount}
        />
      </Box>

      <ItemSearchBar
        placeholder="상품명, 상품번호 또는 브랜드 입력"
        onClick={search}
        keyword={keyword}
        setKeyword={setKeyword}
      />

      <Box height={20} />
      <Box width="1100px">
        <ProductSearchTable
          items={items}
          checked={checked}
          setChecked={setChecked}
        />

        <Navigation
          page={option.page}
          setPage={(page) => {
            setOption((prev) => ({ ...prev, page: page }))
          }}
          count={option.count}
        />
      </Box>

      <Box display="flex" gap={2}>
        <Button
          borderRadius="10px"
          bg="#FFF0F0"
          color="#F57979"
          onClick={() => {
            setOnRegister(null)
          }}
        >
          취소
        </Button>
        <Button borderRadius="10px" onClick={updateItems}>
          저장하기
        </Button>
      </Box>
    </Box>
  )
}
export default RegisterProduct

const boxStyle = {
  marginX: '10px',
  paddingX: '20px',
  marginTop: '10px',
  paddingTop: '16px',
  paddingBottom: '40px',
  backgroundColor: 'white',
  color: '#707070',
}

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: black;
`

const defaultImage = (images) => {
  if (images.length < 12) {
    images = images.concat(new Array(12 - images.length).fill(''))
  }
  return images
}
